import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { BsDash } from "react-icons/bs";
import { FiChevronUp } from "react-icons/fi";
import { sakib, academicEnglishBg } from "../../assets";
import TopBanner from "../../components/designTab/TopBanner";
import CoursesIntro from "../../components/pageProps/CoursesIntro";
import Bonus from "../../components/pageProps/Bonus";

const AcademicEnglish = () => {
  // ================ Course Module start here ==================
  const [showHscOne, setShowHscOne] = useState(true);
  const [showHscThree, setShowHscThree] = useState(false);
  // ================ Course Module end here ====================
  return (
    <div className="w-full h-auto">
      <Helmet>
        <title>Academic English - EduCare English Learning Academy</title>
      </Helmet>
      <TopBanner titleText="Academic English" />
      <div className="max-w-screen-xl mx-auto pb-4 pt-2 px-4 flex flex-col lgl:flex-row items-start xl:gap-10 justify-between">
        <div className="w-full flex flex-col gap-4 md:gap-10">
          <CoursesIntro
            intro="Introduction"
            des="Enroll in our Academic English package & improve your English grammar skill. Enrolling course, will not helpful for the grammar part but also will help you to improve your writing skill."
            instructorName="MD Sakib Rahman"
            instructorTitle="Sr. Instructor, Academic English"
            instructorImg={sakib}
            classTitle="Regular Class"
            classNo="24"
            langClubTitle="LANGUAGE CLUB"
            langClubNo="12"
            debate="Model questions"
            supportTitle="SUPPORT"
            support="24/7"
            bg={academicEnglishBg}
          />
          {/* =====================================================
                        Course overview start here
           ===================================================== */}
          <div>
            <h3 className="font-titleFont text-xl md:text-2xl font-semibold mb-1 md:mb-4">
              Why Academic English course is for you?
            </h3>
            <div className="w-full border hover:shadow-lg transition-hover duration-300 border-primeColor rounded-md border-opacity-30 p-4 flex justify-start items-center gap-4">
              <div>
                <p className="text-[16px] font-bodyFont tracking-wide text-gray-600">
                  After accomplishing the course, one will be able to acquire
                  the efficiency of getting one of the highest marks in English
                  grammar in the SSC examination. Being prepared for upcoming
                  competitive exams e.g. University admission, Medical
                  admission, Job, and even BSC. Writing without any grammatical
                  errors. Speaking English apart from making any grammatical
                  mistakes. Reading along with understanding the exact meaning.
                </p>
              </div>
            </div>
          </div>

          {/* =====================================================
                        Course overview end here
           ===================================================== */}
          {/* =====================================================
                        Course MODULE start here
           ===================================================== */}

          <h3 className="font-titleFont text-xl md:text-2xl font-semibold -mb-4">
            Course Modules
          </h3>
          <div className="w-full border hover:shadow-lg transition-hover duration-200 border-primeColor rounded-md border-opacity-30 p-4">
            {/* =================== HSC Grammer Part Start here ============== */}
            <div>
              <h3
                onClick={() => setShowHscOne(!showHscOne)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Academic English : Grammar part
                {showHscOne ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showHscOne && (
                <>
                  <h4 className="font-bold text-lg text-primeColor w-full border-b-[1px] border-b-darkPink p-2 h-10">
                    SSC :
                  </h4>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli hover:text-primeColor duration-200">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Noun, Pronoun.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Adjective & Determiner.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Article.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Verb (Principle, Auxiliary, Finite, Non-finite, Gerund,
                        Participle, Infinitive).
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Tense & Subject-Verb-Agreement.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        The right form of Verbs & Subject-Verb-Agreement
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Adverb
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Preposition, Appropriate Preposition.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Composition.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Conjunction & Completing Sentence.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Composition.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Completing Sentence & Interjection.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Suffix & Prefix.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Sentence (Classification).
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Affirmative to Negative.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Affirmative to Interrogative.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Composition.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Affirmative to Exclamatory.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Affirmative to Imperative & Optative.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Voice Change.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Comparison of Adjective (Degree).
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Simple- Complex- Compound.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Tag Question.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Sentence Connectors & Substitution Table.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Punctuation & Capitalization.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Model Question-Solving Class- 01.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Model Question-Solving Class- 02.
                      </li>
                    </ul>
                  </div>
                  <h4 className="font-bold text-lg text-primeColor w-full border-b-[1px] border-b-darkPink p-2 h-10">
                    HSC :
                  </h4>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Person, subject, object.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Tense
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Parts of speech
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Noun
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Pronoun
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Adjectives
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Verb
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Adverbs
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Preposition
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Conjunction
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Interjection
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Introductory It & There
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Phrase & Clause
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Sentence
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Linking words.
                      </li>
                    </ul>
                  </div>
                  <h4 className="font-bold text-lg text-primeColor w-full p-2">
                    Academy English (HSC) - Applied grammar for exam
                  </h4>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Article
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Use of prepositions & appropriate prepositions.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Special use of some words and phrases.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Completing Sentence.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Use of the Right forms of verbs. & Subject-verb –
                        Agreement.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Transformation of the sentence.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Narration.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Pronoun reference.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Modifier.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Sentence connector.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Synonym & antonyms.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Punctuation.
                      </li>
                      <li className="courseModuleListliTwo">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Including solving sessions of plenty of model questions
                        along with Previous year's questions for exam
                        preparation.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Providing lecture sheets with exercises for homework as
                        PDF files.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Taking tests in each week according to the lessons that
                        will be taught.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Taking good care of students like a home tutor.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Available to ask any question at any time if the
                        students have any queries about their lessons.
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* =================== Exam Preparation Start here ============== */}

            {/* =================== Reading Start here ============== */}
            <div>
              <h3
                onClick={() => setShowHscThree(!showHscThree)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Course Facilities :
                {showHscThree ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showHscThree && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Including solving sessions of plenty of model questions
                        along with previous year's questions for exam
                        preparation.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Providing lecture sheets with exercises for homework as
                        PDF files.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Taking tests each week according to the lessons that
                        will be taught.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Taking good care of students like a home tutor.
                      </li>
                      <li className="flex gap-2 items-start">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Available to ask any question at any time if the
                        students have any queries about their lessons.
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
          </div>
          <div>
            <Bonus
              bonus="We will provide a short syllabus for your Final Exam."
              awards="Based on your performance, you will be awarded. Also, we will provide you with the certificate after completing the course."
            />
          </div>
          {/* =====================================================
                        Course MODULE end here
           ===================================================== */}
        </div>
      </div>
    </div>
  );
};

export default AcademicEnglish;
